import { Seo } from '../components/Seo';
import { PageHeader } from '../components/PageHeader';
import { Section } from '../components/Section';
import { LegalContent } from '../components/LegalContent';
import { Disclaimer } from '../components/Disclaimer';
import { company } from '../data/site';
import { privacySections } from '../data/legal';
export function PrivacyPolicy() {
  return <>
      <Seo title="Privacy Policy | Futuramy Investment LLC" description="Privacy Policy for the Futuramy Investment LLC website, explaining what information the website may collect, how it may be used and how you can contact the company regarding privacy." path="/privacy-policy" data-id="element-281" data-mp="1izqx4xirpm5p" />
      <PageHeader eyebrow="Legal" title="Privacy Policy" subtitle="How information may be collected and handled in connection with this website." data-id="element-282" data-mp="158lrnespxzng" />
      <Section data-id="element-283" data-mp="21s2xxftrwfdq">
        <LegalContent sections={privacySections} lastUpdated={company.lastUpdated} data-id="element-284" data-mp="1wzrxmbv4erkn" />
      </Section>
      <Disclaimer data-id="element-285" data-mp="51auus8bc76w" />
    </>;
}